export const baseURL = process.env.REACT_APP_BASE_URL
export const baseSocketURL = process.env.REACT_APP_BASE_SOCKET_URL
export const googleMapApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY